// @flow
import React from 'react';
import type { Node } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

type Props = $ReadOnly<{
    label: Node,
    path: $ReadOnlyArray<string>,
    value: boolean,
    className?: string,

    onChange: (path: $ReadOnlyArray<string>, value: boolean) => void
}>;

function BooleanComponent({ label, path, value, className, onChange }: Props) {
    const handleChange = (e) => onChange(path, e.target.checked);

    return (
        <FormControlLabel
            className={className}
            control={
                <Checkbox
                    checked={Boolean(value)}
                    onChange={handleChange}
                    value={value}
                    color="primary"
                />
            }
            label={label}
        />
    );
}

export default BooleanComponent;